import { EventCategory } from '../types';

const img = (id: string) => `/images/${id}.webp`;

export const categories: EventCategory[] = [
  {
    id: 'corporate',
    name: 'Corporate',
    tagline: 'Boardroom to ballroom',
    description:
      'Conferences, product launches, gala dinners and brand activations engineered with executive precision.',
    image: img('1511795409834-ef04bbd61622'),
    accent: '#e10a1e',
    count: '01',
  },
  {
    id: 'social',
    name: 'Social',
    tagline: 'Moments worth remembering',
    description:
      'Weddings, anniversaries, birthdays and milestone celebrations crafted around the people at their center.',
    image: img('1519741497674-611481863552'),
    accent: '#c9a14a',
    count: '02',
  },
  {
    id: 'cultural',
    name: 'Cultural',
    tagline: 'Heritage in motion',
    description:
      'Festivals, exhibitions and cultural showcases that honour tradition while staging a contemporary spectacle.',
    image: img('1533174072545-7a4b6ad7a6c3'),
    accent: '#e10a1e',
    count: '03',
  },
  {
    id: 'sporting',
    name: 'Sporting',
    tagline: 'Stadium-grade theatre',
    description:
      'Tournaments, league finals and athlete-led activations produced with broadcast-ready execution.',
    image: img('1461896836934-ffe607ba8211'),
    accent: '#c9a14a',
    count: '04',
  },
  {
    id: 'academic',
    name: 'Academic',
    tagline: 'Conferences with consequence',
    description:
      'Symposiums, graduation ceremonies and university summits delivered with institutional rigor.',
    image: img('1523580494863-6f3031224c94'),
    accent: '#e10a1e',
    count: '05',
  },
  {
    id: 'religious',
    name: 'Religious',
    tagline: 'Reverence, perfectly staged',
    description:
      'Ceremonies, pilgrimages and faith-led gatherings produced with quiet dignity and complete care.',
    image: img('1507692049790-de58290a4334'),
    accent: '#c9a14a',
    count: '06',
  },
  {
    id: 'entertainment',
    name: 'Entertainment',
    tagline: 'Concerts, tours, spectacle',
    description:
      'Headline concerts, festivals and theatrical productions — built for crowds, paced for emotion.',
    image: img('1493225457124-a3eb161ffa5f'),
    accent: '#e10a1e',
    count: '07',
  },
  {
    id: 'political',
    name: 'Political',
    tagline: 'State-grade choreography',
    description:
      'Summits, conventions and campaign milestones executed with diplomacy, discretion and detail.',
    image: img('1529107386315-e1a2ed48a620'),
    accent: '#c9a14a',
    count: '08',
  },
];
